// V1
// import { Meta } from "../../meta/meta";
// import { useTranslation } from "react-i18next";
// import useQueryParams from "../../hooks/useQueryParams";
// import { GoBack } from "../../components/ui/goBack";
// import { Title } from "../../components/ui/typography/title";
// import { Form } from "../../components/ui/form";
// import { useState } from "react";
// import useMediaQuery from "../../hooks/useMediaQuery";
// import { Link, useParams } from "react-router-dom";
// import Highlighter from "react-highlight-words";
// import ReactPaginate from "react-paginate";
// import { filters } from "../../utils/constants";
// import { useWebSearch } from "../../services/search";
// import { Loader } from "../../components/ui/loader";
// import styles from "./search.module.scss";
// import { smoothScroll } from "../../utils/helpers";

// const Search = () => {
//   const mobile = useMediaQuery(`( max-width: 768px )`);

//   const { t } = useTranslation();
//   const { language } = useParams();

//   const [query, setQuery] = useQueryParams(["query"]);
//   const [active, setActive] = useQueryParams(["filter"], "all");

//   const { data, loading } = useWebSearch({ language, search: query });

//   const [selectedPage, setSelectedPage] = useState(1);
//   const [itemOffset, setItemOffset] = useState(0);

//   const itemsPerPage = 6;
//   const endOffset = itemOffset + itemsPerPage;
//   const currentDataFiltered = data?.filter(
//     (item) => active === "all" || active === item.type
//   );
//   const currentData = currentDataFiltered?.slice(itemOffset, endOffset);
//   const pageCount = Math.ceil(currentDataFiltered?.length / itemsPerPage);

//   const handlePageClick = (event) => {
//     const newOffset =
//       (event.selected * itemsPerPage) % currentDataFiltered?.length;
//     setItemOffset(newOffset);
//     const newSelectedPage = Math.ceil((newOffset + 1) / itemsPerPage);
//     setSelectedPage(newSelectedPage);
//     smoothScroll();
//   };

//   const handleFilter = (name) => {
//     setActive({ filter: name });
//     setSelectedPage(1);
//     setItemOffset(0);
//     smoothScroll();
//   };

//   const arrowPrev = !mobile ? t("prev") : "<";
//   const arrowNext = !mobile ? t("next") : ">";

//   return (
//     <>
//       <Meta title="search_title" description="" />
//       <main className={styles.search}>
//         <div className="container">
//           <GoBack />

//           <div className={styles.search_context}>
//             <div className={styles.search_context_top}>
//               <Title
//                 length={
//                   currentDataFiltered?.length !== 0
//                     ? currentDataFiltered?.length
//                     : "0"
//                 }
//                 text="search_title"
//               />
//               <Form query={query} setQuery={setQuery} />

//               <div className={styles.search_filters}>
//                 {filters?.map(({ name, icon }) => {
//                   return (
//                     <button
//                       key={name}
//                       title={t(name)}
//                       className={
//                         active === name
//                           ? styles.search_filters_btnActive
//                           : styles.search_filters_btn
//                       }
//                       onClick={() => handleFilter(name)}
//                       disabled={!data?.length}
//                       style={{
//                         cursor: !data?.length ? "not-allowed" : "pointer",
//                       }}
//                       type="button"
//                       aria-label={t(name)}
//                     >
//                       {icon} {t(name)}
//                     </button>
//                   );
//                 })}
//               </div>

//               {loading ? (
//                 <Loader />
//               ) : (
//                 <div className={styles.search_result}>
//                   {data?.length
//                     ? currentData?.map(({ id, name, text, path, type }) => {
//                         return (
//                           <div key={id} className={styles.search_result_col}>
//                             {type === "useful_links" ? (
//                               <a
//                                 href={path}
//                                 className={styles.search_result_title}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                               >
//                                 <Highlighter
//                                   highlightClassName="Highlight"
//                                   searchWords={[query]}
//                                   autoEscape={true}
//                                   textToHighlight={name}
//                                 />
//                               </a>
//                             ) : (
//                               <Link
//                                 // to={
//                                 //   type === "services" || type === "partners"
//                                 //     ? `${path}`
//                                 //     : type === "news"
//                                 //     ? `/${language}/news/${id}`
//                                 //     : `/${language}/${path}`
//                                 // }
//                                 to={
//                                   type === "news"
//                                     ? `/${language}/news/${id}`
//                                     : `/${language}/${path}`
//                                 }
//                                 className={styles.search_result_title}
//                               >
//                                 <Highlighter
//                                   highlightClassName="Highlight"
//                                   searchWords={[query]}
//                                   autoEscape={true}
//                                   textToHighlight={name}
//                                 />
//                               </Link>
//                             )}

//                             <p className={styles.search_result_text}>
//                               <Highlighter
//                                 highlightClassName="Highlight"
//                                 searchWords={[query]}
//                                 autoEscape={true}
//                                 textToHighlight={text}
//                               />
//                             </p>
//                           </div>
//                         );
//                       })
//                     : null}
//                 </div>
//               )}
//               <ReactPaginate
//                 key={active}
//                 breakLabel="..."
//                 onPageChange={handlePageClick}
//                 pageRangeDisplayed={1}
//                 pageCount={pageCount}
//                 previousLabel={selectedPage > 1 ? arrowPrev : null}
//                 nextLabel={selectedPage < pageCount ? arrowNext : null}
//                 renderOnZeroPageCount={null}
//                 containerClassName={styles.pagination}
//                 activeClassName={styles.paginationActive}
//               />
//             </div>
//           </div>
//         </div>
//       </main>
//     </>
//   );
// };

// export default Search;

// V2
import { Meta } from "../../meta/meta";
import { useTranslation } from "react-i18next";
import useQueryParams from "../../hooks/useQueryParams";
import { GoBack } from "../../components/ui/goBack";
import { Title } from "../../components/ui/typography/title";
import { Form } from "../../components/ui/form";
import useMediaQuery from "../../hooks/useMediaQuery";
import { Link, useParams } from "react-router-dom";
import Highlighter from "react-highlight-words";
import ReactPaginate from "react-paginate";
import { filters } from "../../utils/constants";
import { useWebSearch } from "../../services/search";
import { Loader } from "../../components/ui/loader";
import { smoothScroll } from "../../utils/helpers";
import styles from "./search.module.scss";

const Search = () => {
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const { t } = useTranslation();
  const { language } = useParams();

  const [{ query, filter, page }, setQuery] = useQueryParams({
    query: "",
    filter: "all",
    page: 1,
  });

  const { data, loading } = useWebSearch({ language, search: query });

  const itemsPerPage = 6;
  const currentDataFiltered = data?.filter(
    (item) => filter === "all" || filter === item.type
  );
  const pageCount = Math.ceil(
    (currentDataFiltered?.length || 0) / itemsPerPage
  );
  const itemOffset = (page - 1) * itemsPerPage;
  const endOffset = itemOffset + itemsPerPage;
  const currentData = currentDataFiltered?.slice(itemOffset, endOffset);

  const currentPage = Number(page) || 1;

  const handlePageClick = (event) => {
    setQuery({ page: event.selected + 1 });
    smoothScroll();
  };

  const handleFilter = (name) => {
    setQuery({ filter: name, page: 1 });
    smoothScroll();
  };

  const arrowPrev = !mobile ? t("prev") : "<";
  const arrowNext = !mobile ? t("next") : ">";

  return (
    <>
      <Meta title="search_title" description="" />
      <main className={styles.search}>
        <div className="container">
          <GoBack />

          <div className={styles.search_context}>
            <div className={styles.search_context_top}>
              <Title
                length={
                  currentDataFiltered?.length !== 0
                    ? currentDataFiltered?.length
                    : "0"
                }
                text="search_title"
              />
              <Form
                query={query}
                setQuery={(value) => setQuery({ query: value, page: 1 })}
              />

              <div className={styles.search_filters}>
                {filters?.map(({ name, icon }) => {
                  return (
                    <button
                      key={name}
                      title={t(name)}
                      className={
                        filter === name
                          ? styles.search_filters_btnActive
                          : styles.search_filters_btn
                      }
                      onClick={() => handleFilter(name)}
                      disabled={!data?.length}
                      style={{
                        cursor: !data?.length ? "not-allowed" : "pointer",
                      }}
                      type="button"
                      aria-label={t(name)}
                    >
                      {icon} {t(name)}
                    </button>
                  );
                })}
              </div>

              {loading ? (
                <Loader />
              ) : (
                <div className={styles.search_result}>
                  {data?.length
                    ? currentData?.map(({ id, name, text, path, type }) => {
                        return (
                          <div key={id} className={styles.search_result_col}>
                            {type === "useful_links" ? (
                              <a
                                href={path}
                                className={styles.search_result_title}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <Highlighter
                                  highlightClassName="Highlight"
                                  searchWords={[query]}
                                  autoEscape={true}
                                  textToHighlight={name}
                                />
                              </a>
                            ) : (
                              <Link
                                // to={
                                //   type === "services" || type === "partners"
                                //     ? `${path}`
                                //     : type === "news"
                                //     ? `/${language}/news/${id}`
                                //     : `/${language}/${path}`
                                // }
                                to={
                                  type === "news"
                                    ? `/${language}/news/${id}`
                                    : `/${language}/${path}`
                                }
                                className={styles.search_result_title}
                              >
                                <Highlighter
                                  highlightClassName="Highlight"
                                  searchWords={[query]}
                                  autoEscape={true}
                                  textToHighlight={name}
                                />
                              </Link>
                            )}

                            <p className={styles.search_result_text}>
                              <Highlighter
                                highlightClassName="Highlight"
                                searchWords={[query]}
                                autoEscape={true}
                                textToHighlight={text}
                              />
                            </p>
                          </div>
                        );
                      })
                    : null}
                </div>
              )}
              <ReactPaginate
                // key={active}
                breakLabel="..."
                onPageChange={handlePageClick}
                pageRangeDisplayed={1}
                pageCount={pageCount}
                previousLabel={currentPage > 1 ? arrowPrev : null}
                nextLabel={currentPage < pageCount ? arrowNext : null}
                renderOnZeroPageCount={null}
                containerClassName={styles.pagination}
                activeClassName={styles.paginationActive}
                forcePage={currentPage - 1}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Search;
